'use strict';

/*global isEmpty */
/*global google */

function MapItemAbstract(data) {
    this.itemID             = !isEmpty(data) && data.hasOwnProperty('item_id')            ? data.item_id              : '';
    this.itemDriveID        = !isEmpty(data) && data.hasOwnProperty('item_drive_id')      ? data.item_drive_id        : '';
    this.type               = !isEmpty(data) && data.hasOwnProperty('type')               ? data.type                 : '';

    //adresa
    this.country            = !isEmpty(data) && data.hasOwnProperty('country')            ? data.country              : '';
    this.city               = !isEmpty(data) && data.hasOwnProperty('city')               ? data.city                 : '';
    this.street             = !isEmpty(data) && data.hasOwnProperty('street')             ? data.street               : '';
    this.house_number       = !isEmpty(data) && data.hasOwnProperty('house_number')       ? data.house_number         : '';
    this.zipcode            = !isEmpty(data) && data.hasOwnProperty('zipcode')            ? data.zipcode              : '';

    //souradnice
    this.latitude           = !isEmpty(data) && data.hasOwnProperty('latitude')           ? data.latitude             : '';
    this.longitude          = !isEmpty(data) && data.hasOwnProperty('longitude')          ? data.longitude            : '';
    this.altitude           = !isEmpty(data) && data.hasOwnProperty('altitude')           ? data.altitude             : '';
    this.partial_match      = !isEmpty(data) && data.hasOwnProperty('partial_match')      ? data.partial_match        : '';

    //dalsi
    this.date               = !isEmpty(data) && data.hasOwnProperty('date')               ? data.date                 : '';

    //marker
    this.marker             = !isEmpty(data) && data.hasOwnProperty('marker')             ? data.marker               : '';
    this.editable           = !isEmpty(data) && data.hasOwnProperty('editable')           ? data.editable             : true;
    this.selectable         = !isEmpty(data) && data.hasOwnProperty('selectable')         ? data.selectable           : true;
    this.draggable          = !isEmpty(data) && data.hasOwnProperty('draggable')          ? data.draggable            : false;

    //gui
    this.icon               = !isEmpty(data) && data.hasOwnProperty('icon')               ? data.icon                 : '';
    this.title              = !isEmpty(data) && data.hasOwnProperty('title')              ? data.title                : '';
    this.image              = !isEmpty(data) && data.hasOwnProperty('image')              ? data.image                : '';
    this.toolTip            = !isEmpty(data) && data.hasOwnProperty('toolTip')            ? data.toolTip              : '';
    this.label              = !isEmpty(data) && data.hasOwnProperty('label')              ? data.label                : '';
    this.labelY             = !isEmpty(data) && data.hasOwnProperty('label_y')            ? data.label_y              : '';
    this.labelX             = !isEmpty(data) && data.hasOwnProperty('label_x')            ? data.label_x              : '';
}

MapItemAbstract.prototype = $.extend({}, {
    construtor: 'MapItemAbstract',

    setIcon: function setIcon(icon) {
        var _this = this;

        _this.icon = icon;
        if(_this.marker) {
            _this.marker.setIcon(_this.icon);
        }
        return _this;
    },

    setZIndex: function setZIndex(zIndex) {
        var _this = this;

        if(_this.marker) {
            _this.marker.setZIndex(zIndex);
        }
        return _this;
    },

    hideIcon: function hideIcon() {
        var _this = this;

        if(_this.marker) {
            _this.marker.setVisible(false);
        }
        return _this;
    },

    showIcon: function showIcon() {
        var _this = this;

        if(_this.marker) {
            _this.marker.setVisible(true);
        }
        return _this;
    },

    //nacte adresu z objektu vraceneho z google do vlastniho objektu
    loadAddressFromResult: function loadAddressFromResult(result) {
        var _this = this;

        _this.country = _this.city = _this.street = _this.zipcode = _this.house_number = '';
        if(result.address_components.length === 1 && result.address_components[0].types === 'natural_feature,establishment') {
            _this.country = result.address_components[0].long_name;
        } else {
            for(var j = 0; j < result.address_components.length; j++) {
                if(result.address_components[j].types === 'country,political') {
                    _this.country = result.address_components[j].long_name;
                } else if(result.address_components[j].types === 'locality,political') {
                    _this.city = result.address_components[j].long_name;

                //} else if(result.address_components[j].types === 'political,sublocality,sublocality_level_1') {
                    //_this.city = result.address_components.[j].long_name;
                } else if(result.address_components[j].types === 'route') {
                    _this.street = result.address_components[j].long_name;
                } else if(result.address_components[j].types === 'postal_code') {
                    _this.zipcode = result.address_components[j].long_name;
                } else if(result.address_components[j].types === 'premise') {
                    _this.house_number = result.address_components[j].long_name;
                }
            }
        }
        return _this;
    },

    getStrAddress: function getStrAddress() {
        var _this = this;

        var address = '';
        if(!isEmpty(_this.street)) {
            address += _this.street + ' ';
        }
        if(!isEmpty(_this.house_number)) {
            address += _this.house_number + ' ';
        }
        if(!isEmpty(address)) {
            address = $.trim(address) + ', ';
        }
        if(!isEmpty(_this.city)) {
            address += _this.city + ' ';
        }
        if(!isEmpty(_this.zipcode)) {
            address += _this.zipcode + ' ';
        }
        if(!isEmpty(address)) {
            address = $.trim(address);
        }
        if(!isEmpty(_this.country)) {
            address += ', ' + _this.country + ' ';
        }
        return address;
    },

    getLatLng: function getLatLng() {
        var _this = this;

        return new google.maps.LatLng(parseFloat(_this.latitude), parseFloat(_this.longitude));
    },

    removeFromMap: function removeFromMap() {
        var _this = this;

        if(_this.marker) {
            _this.marker.setMap(null);
            _this.marker = null;
        }
        return _this;
    },

    copyFromMapItem: function copyFromMapItem(mapItem) {
        var _this = this;

        for(var param in _this) {
            if($.inArray(param, ['marker']) < 0) {
                _this[param] = mapItem[param];
            }
        }
        return _this;
    },

    serialize: function serialize() {
        var _this = this;

        var str = '';
        for(var param in _this) {
            if($.inArray(param, ['marker']) < 0) {
                if(typeof _this[param] !== 'function') {
                    if(str.length) {
                        str += '&';
                    }
                    str += param + '=' + _this[param];
                }
            }
        }
        return str;
    }
});
